import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow
} from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Link } from 'react-router-dom';
import ImagePopoverAvatar from './ImagePopoverAvatar';

import '../assets/stylesheets/EmployeeInfoTable.css';
import i18n from '../i18n';
import { AM_LABEL, PM_LABEL } from '../constants/general';

class EmployeeInfoTable extends Component {
  getAttributeNames = attributeControls => {
    return attributeControls.map(attribute => {
      if (attribute.attributeName === 'birthday') {
        return 'age';
      }
      return attribute.attributeName;
    });
  };

  // This is a function to dynamically build rows depending on the structure of employee objects.
  buildBody = (attributeControls, positionId, employees) => {
    const { selectedEmployeeIds } = this.props;

    const rows = employees.map(employee => {
      let rowClassName = 'employeeInfoRow';
      if (selectedEmployeeIds.includes(employee.id)) {
        rowClassName += ' selected';
      }
      switch (employee.availabilityType) {
        case AM_LABEL:
          rowClassName += ' availableAM';
          break;
        case PM_LABEL:
          rowClassName += ' availablePM';
          break;
        default:
          break;
      }
      const cellClassName = 'employeeInfoCell';

      const extraCells = attributeControls.map(attribute => {
        let { attributeName } = attribute;
        const { valueType } = attribute;
        if (attributeName === 'birthday') {
          attributeName = 'age';
        }
        let content =
          employee.positions[positionId].StudioEmployee_Position.extras[
            attributeName
          ];
        if (valueType === 'boolean') {
          content = content ? <CheckCircleIcon color="secondary" /> : '';
        }
        if (valueType === 'image') {
          content = <ImagePopoverAvatar src={content} />;
        }
        return (
          <TableCell
            className={cellClassName}
            key={`${employee.id}-${attribute.attributeName}`}
          >
            {content}
          </TableCell>
        );
      });

      const { isContractor } = employee;

      return (
        <TableRow
          className={rowClassName}
          key={employee.id}
        >
          <TableCell>
            <ImagePopoverAvatar src={employee.profileImage} />
          </TableCell>

          <TableCell className={`${cellClassName} nameField`}>
            {employee.name}
          </TableCell>
          <TableCell className={cellClassName}>
            {i18n.t(employee.employeeType)}
          </TableCell>
          <TableCell className={cellClassName}>
            {i18n.t(employee.primaryPosition ? employee.primaryPosition : 'userProfile:noPosition')}
          </TableCell>
          <TableCell className={cellClassName}>
            {i18n.t(employee.abilityTier)}
          </TableCell>
          <TableCell className={cellClassName}>{employee.origins[0]}</TableCell>
          <TableCell className={cellClassName}>
            {employee.nationalities[0]}
          </TableCell>
          <TableCell className={cellClassName}>
            <Link to={`/user-profile/${employee.id}`}>
              <LinkIcon />
            </Link>
          </TableCell>
          {isContractor ? ( // If the employee is a contractor, we want to show contractor-specific information.
            <TableCell className={cellClassName}>
              {/* TODO parse the object */}
              {employee.positions[positionId].StudioEmployee_Position.rate['1 Day']}
            </TableCell>
          ) : (
            // Otherwise, we want to show that some information is not available for full-time employees.
            <TableCell className="employeeInfoCell">
              {i18n.t('booking:notAvailForFTEmployees')}
            </TableCell>
          )}
          {extraCells}
        </TableRow>
      );
    });
    return <TableBody>{rows}</TableBody>;
  };

  render() {
    const { positionId, employees, attributeControls } = this.props;

    if (positionId && employees) {
      const attributeNames = this.getAttributeNames(attributeControls);

      return (
        <Paper className="employeeInfoContainer">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:profileImage')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:name')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('employeeType')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('primaryPosition')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:abilityTier')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:origins')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:nationalities')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:userProfile')}
                </TableCell>
                <TableCell className="employeeInfoHeader">
                  {i18n.t('booking:fullDayRate')}
                </TableCell>
                {attributeNames.map(attributeName => (
                  <TableCell className="employeeInfoHeader" key={attributeName}>
                    {i18n.t(`booking:${attributeName}`)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {this.buildBody(attributeControls, positionId, employees)}
          </Table>
        </Paper>
      );
    }
    return (
      <Paper className="employeeInfoContainer">
        <p className="emptyStateHeader">
          {i18n.t('booking:noDataInTableHeader')}
        </p>
        <p className="emptyStateDescription">
          {i18n.t('booking:noDataInTableDescription')}
        </p>
      </Paper>
    );
  }
}

EmployeeInfoTable.defaultProps = {
  attributeControls: null,
  positionId: null
};

EmployeeInfoTable.propTypes = {
  employees: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedEmployeeIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  positionId: PropTypes.number,
  attributeControls: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool, PropTypes.number])),
};

export default EmployeeInfoTable;
